import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import StuffCounter from './StuffCounter';
import StuffEtcInput from './StuffEtcInput';

// 물품·수량 목록 — 퀵(서류·소박스·중박스·대박스)과 화물(팔레트·박스·가구/집기·기타)이 같은 모양으로 쓴다.
// items: [{ name, title, icon, max?, ... }]  values: 스토어 options  onChange(name, value)
// 목록에 etcName('etcCnt') 항목이 있고 1개 이상이면 아래에 물품 설명 칸(etcDescName)을 편다.
const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  dense: {},
}));

function StuffList({
  items, values = {}, onChange,
  renderHelp, onHelp, dense = false,
  etcName = 'etcCnt', etcDescName = 'etcDesc', etcPlaceholder,
}) {
  const cs = useStyles();
  const hasEtc = items.some((it) => it.name === etcName);
  const etcOn = hasEtc && (parseInt(values[etcName], 10) || 0) > 0;

  return (
    <div className={clsx(cs.root, dense && cs.dense)}>
      {items.map((item) => (
        <StuffCounter
          key={item.name}
          item={item}
          value={values[item.name]}
          max={item.max}
          onChange={onChange}
          renderHelp={renderHelp}
          onHelp={onHelp}
          dense={dense}
        />
      ))}
      {etcOn && (
        <StuffEtcInput
          dense={dense}
          value={values[etcDescName] || ''}
          placeholder={etcPlaceholder}
          onChange={(v) => onChange(etcDescName, v)}
        />
      )}
    </div>
  );
}

export default StuffList;
